import { render, staticRenderFns } from "./mobile-register-addr.vue?vue&type=template&id=6052597e&scoped=true&"
import script from "./mobile-register-addr.vue?vue&type=script&lang=js&"
export * from "./mobile-register-addr.vue?vue&type=script&lang=js&"
import style0 from "./mobile-register-addr.vue?vue&type=style&index=0&id=6052597e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052597e",
  null
  
)

export default component.exports